import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
export const QATab = /*#__PURE__*/ memo(function QATab() {
    return /*#__PURE__*/ _jsx("div", {
        className: "py-12 text-center",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "max-w-md mx-auto space-y-4",
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text-lg font-semibold text-gray-900",
                    children: "Q&A Section"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-gray-600",
                    children: "Collaborate with your team on questions and answers for the proposal response."
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-sm text-gray-500",
                    children: "This feature is planned for a future release."
                })
            ]
        })
    });
});
